import * as React from "react";
import { forwardRef } from "react";
const SvgReceptive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M9 3L9 5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3 19L6 19",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6 9L19 9",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15 3L15 5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15 18H17C18.1046 18 19 17.1046 19 16V7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V12V15.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.0195 12.3473L14.5158 14.0113L11.1878 19.0037L9.38501 19.0038L8.69156 17.3397L12.0195 12.3473Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgReceptive);
export default ForwardRef;
